<template>
    <div class="c-card">
        <span
            v-if="asset"
            class="c-card__asset"
        >
            <Img
                :data-src="asset.url"
                :alt="asset.title"
                :width="asset.width"
                :height="asset.height"
                :classes="''"
            ></Img>
        </span>
        <div
            v-if="content"
            v-html="content"
            class="c-card__content | t-cms"
        ></div>
    </div>
</template>

<script>
import Img from 'templates/objects/Img';

export default {
    name: 'Card',
    components: {
        Img,
    },
    props: {
        asset: {
            type: Object,
            default: {
                title: 'Image title',
                url: 'https://source.unsplash.com/1600x900/?city',
            },
        },
        content: {
            type: String,
            default: '',
        },
    },
};
</script>

<style lang="scss" scoped>

    .c-card {
    }

    .c-card__asset {
        display: block;
        width: calc(100% - 2em);
        height: 0;
        margin-right: auto;
        margin-left: auto;
        padding-top: 70%;

        img {
            position: absolute;
            bottom: 0;
            left: 50%;
            display: block;
            transform: translate(-50%, 0);

            @supports (object-fit: contain) {
                object-fit: contain;
                width: 100%;
                height: 100%;
            }

            @supports not (object-fit: contain) {
                width: auto;
                max-width: 100%;
                height: auto;
                max-height: 100%;
            }
        }

        @screen lg {
            padding-right: 2em;
            padding-left: 2em;
        }
    }

    .c-card__content {
        padding: 2em;
        background-color: $color-light;
        border-radius: $radius;
        box-shadow: $shadow;

        @screen lg {
            padding: 2.5em 3.25em;
        }
    }

</style>
